
import { Component, Prop, Vue } from "vue-property-decorator";
import MatchInterface from "@/libs/model/MatchInterface";

@Component({})
export default class DateComponent extends Vue
{
  @Prop() matchdata: MatchInterface;
  get date() {
    if(this.matchdata.liveData && this.matchdata.liveData.matchDetails && this.matchdata.liveData.matchDetails.matchStatus === "Postponed"){
      if(this.matchdata.matchInfo && (!this.matchdata.matchInfo.date || this.matchdata.matchInfo.date === "")) {
        return "";
      }
    }

    if(this.matchdata.liveData && this.matchdata.liveData.matchDetails && this.matchdata.liveData.matchDetails.matchStatus === "Abandoned"){
      return "";
    }
    
    let dateTime = new Date(`${this.matchdata.matchInfo.date.replace('Z','')}T${this.matchdata.matchInfo.time}`);
    return new Intl.DateTimeFormat('en-US', {month: 'short', day: 'numeric', year: 'numeric'}).format(dateTime);
  }

  get dateboxClass() {
    let dateTime = new Date(`${this.matchdata.matchInfo.localDate.replace('Z','')}T${this.matchdata.matchInfo.localTime}`);
    let todayDateTime = new Date();
    let todayDateTimeQatar = new Date(todayDateTime.toLocaleString('en-US', {
      timeZone: 'Asia/Qatar'
    }));

    if(dateTime.getFullYear() === todayDateTimeQatar.getFullYear() && dateTime.getMonth() === todayDateTimeQatar.getMonth() && dateTime.getDate() === todayDateTimeQatar.getDate()){
      return 'datebox-default datebox-green';
    }
    return 'datebox-default';
  }
}
